import React, { Component } from 'react';
import Videolist from './../molecules/VideoList';
import PlaylistRow from './../molecules/PlaylistRow';
import VideoModal from './VideoModal';
import InputSearch from './../atoms/InputSearch';
// (removed) import iconYoutube from './../../assets/youtube-symbol.png';
import servicegetVideos from './../../Services/VideosService';
import { getProductLabel } from './../../Services/productLabels';
import Loadergift from './../atoms/Loader';
import Textheader from './../atoms/HeaderText';

import './VideosController.css';

const YouTubeMark = ({ className }) => (
  <svg className={className} width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32.3625 3.63233C31.9817 2.20183 30.8633 1.07766 29.4402 0.694736C26.8636 2.20054e-07 16.5268 0 16.5268 0C16.5268 0 6.19007 2.20054e-07 3.61337 0.694736C2.19034 1.07766 1.07204 2.20183 0.691112 3.63233C2.18906e-07 6.22254 0 11.63 0 11.63C0 11.63 2.18906e-07 17.0375 0.691112 19.6277C1.07204 21.0582 2.19034 22.1824 3.61337 22.5652C6.19007 23.26 16.5268 23.26 16.5268 23.26C16.5268 23.26 26.8636 23.26 29.4402 22.5652C30.8633 22.1824 31.9817 21.0582 32.3625 19.6277C33.0537 17.0375 33.0537 11.63 33.0537 11.63C33.0537 11.63 33.0509 6.22254 32.3625 3.63233Z" fill="#FF0000"/>
    <path d="M13.2183 16.5272L21.8055 11.5698L13.2183 6.61224V16.5272Z" fill="white"/>
  </svg>
);

export default class VideoController extends Component {
  constructor(props){
    super(props);
    this.fixedRef = React.createRef();
    this.updatePlaneTop = this.updatePlaneTop.bind(this);
  }

  _raf = null;

  data = {
    videos: [],
    orderByAsc: true,
    searchText: '',
    isFirtsTime: true,
    filterBy: 'Duration',
    indexPage: 1,
    response: null,
    statusLoadingIcon: 'none',
    message: '',
    product: '',
    products: [],           // distinct backend product values (filter chips), from the unfiltered listing
    view: 'landing',        // 'landing' | 'expanded'
    activeProduct: '',      // product shown in expanded view ('' = all)
    activeVideoUrl: '',     // URL of the video open in the shared modal ('' = closed)
  };

  // Backend product value (lowercase) → title / subtitle for the landing rows.
  static GROUP_LABELS = {
    partsbase: { title: 'PartsBase', subtitle: 'The essentials to get more from PartsBase.' },
    govgistic: { title: 'Government Data', subtitle: 'Learn the basics and explore Government Data.' },
  };

  static groupMeta = (key) =>
    VideoController.GROUP_LABELS[String(key || '').toLowerCase()] || null;

  updatePlaneTop = () => {
    if (this._raf) return;

    this._raf = requestAnimationFrame(() => {
      const root = document.documentElement;

      // Ancla: el link de YouTube; fallback por si cambia el DOM
      const anchor =
        document.querySelector('.linkVideos a') ||
        document.querySelector('.FixedpositionSearch') ||
        document.querySelector('.TitleHeader');

      const EXTRA = 86.59; // px, de Figma
      let minTop = 370;    // fallback seguro (valor por defecto)

      if (anchor) {
        const r = anchor.getBoundingClientRect();
        // bottom del link + separación; nunca negativo
        minTop = Math.max(0, Math.round(r.bottom + EXTRA));
      }

      root.style.setProperty('--plane-min-top', `${minTop}px`);
      this._raf = null;
    });
  };


  _getVideos = async (filter) => {
    // Cancel any in-flight request so a slow, older response can't overwrite a newer one.
    if (this._abort) this._abort.abort();
    const requestId = (this._requestId || 0) + 1;
    this._requestId = requestId;
    const controller = typeof AbortController === 'undefined' ? null : new AbortController();
    this._abort = controller;

    this.data.message = '';
    this.data.videos = null;
    this.data.statusLoadingIcon = 'block';
    this.setState(this.data);
    // The backend `search` only matches titles, not the product field. If the
    // search text is the active product's name (raw value or UI label), the
    // product filter alone already yields exactly those cards.
    const search = (filter.searchText || '').trim().toLowerCase();
    const product = filter.product || '';
    const matchesActiveProduct = product && search &&
      (search === product.toLowerCase() ||
        search === String(getProductLabel(product)).toLowerCase());
    const response = await servicegetVideos({
      ...filter,
      searchText: matchesActiveProduct ? '' : filter.searchText,
      signal: controller ? controller.signal : undefined,
    });
    if (this._requestId !== requestId) return; // superseded or unmounted
    this._abort = null;
    this.data.statusLoadingIcon = 'none';
    this.setState(this.data);

    this.data.response = response;
    if (!this.data.response.ok) {
      this.data.message = 'Sorry - but we do not have data for this search';
    } else {
      if (this.data.response.data === null)
        this.data.message = 'Sorry - but we do not have data for this search';
      else if (this.data.response.data.items.length === 0)
        this.data.message = 'Sorry - but we do not have data for this search';
    }
    this.data.videos = this.data.response.data !== null ? this.data.response.data.items : null;
    // Chips come from the unfiltered listing; a filtered/searched response would shrink them.
    if (this.data.videos && !filter.product && !filter.searchText) {
      this.data.products = [...new Set(this.data.videos.map((v) => v.product).filter(Boolean))];
    }
    this.setState(this.data);
  };

  async componentDidMount() {
    document.title = 'Resources';
    this.updatePlaneTop();
    window.addEventListener('scroll', this.updatePlaneTop, { passive: true });
    window.addEventListener('resize', this.updatePlaneTop, { passive: true });
    window.addEventListener('load', this.updatePlaneTop);
    // Load everything once — the landing view groups by product client-side,
    // and the expanded view filters from the same set.
    this._getVideos(this.data);
  }

  componentWillUnmount() {
    this._requestId = (this._requestId || 0) + 1;
    window.removeEventListener('scroll', this.updatePlaneTop);
    window.removeEventListener('resize', this.updatePlaneTop);
    window.removeEventListener('load', this.updatePlaneTop);

    if (this._raf) {
      cancelAnimationFrame(this._raf);
    }
    if (this._abort) {
      this._abort.abort();
      this._abort = null;
    }
  }


  _OnTextChanged = (text) => {
    try {
      this.data.searchText = text;
      this._getVideos(this.data);
    } catch (error) {
      console.log(error);
    }
  };

  _OnFilterChanged = (filterBy, orderByAsc) => {
    try {
      this.data.filterBy = filterBy;
      this.data.orderByAsc = orderByAsc;
      this._getVideos(this.data);
    } catch (error) {
      console.log(error);
    }
  };

  _OnProductChange = (product) => {
    try {
      // '' (All) sends no `product` param; otherwise the raw backend value.
      this.data.product = product || '';
      this.data.activeProduct = this.data.product;
      this._getVideos(this.data);
    } catch (error) {
      console.log(error);
    }
  };

  _openVideo = (url) => {
    if (!url) return;
    this.data.activeVideoUrl = url;
    this.setState(this.data);
  };

  _closeVideo = () => {
    this.data.activeVideoUrl = '';
    this.setState(this.data);
  };

  _exploreProduct = (product) => {
    this.data.view = 'expanded';
    this.data.activeProduct = product;
    this.data.product = product;
    this.data.searchText = '';
    this.data.isFirtsTime = false;
    this.setState(this.data);
    this._getVideos(this.data);
  };

  _backToLanding = () => {
    this.data.view = 'landing';
    this.data.activeProduct = '';
    this.data.product = '';
    this.data.searchText = '';
    this.setState(this.data);
    this._getVideos(this.data);
  };

  _groupByProduct = (videos) => {
    // Opening/closing the modal re-renders; reuse the grouping unless the data changed.
    if (this._groupsSrc === videos && this._groups) return this._groups;
    const groups = {};
    (videos || []).forEach((v) => {
      const key = v.product || 'Other';
      if (!groups[key]) groups[key] = [];
      groups[key].push(v);
    });
    this._groupsSrc = videos;
    this._groups = groups;
    return groups;
  };

  render() {
    const { videos, statusLoadingIcon, message, orderByAsc, view, activeProduct, activeVideoUrl, products } = this.data;
    const groups = this._groupByProduct(videos);
    const groupKeys = Object.keys(groups);
    const activeLabel =
      (VideoController.groupMeta(activeProduct) || {}).title || getProductLabel(activeProduct) || 'Demos';
    return (
      <div className='VideoController video-page'>
        {/* Capa del avión animada por CSS (transform con --plane-y) */}
        <div className="plane-layer" aria-hidden="true" />

        <div className='containerCentral'>
          <div className='MainContainer'>
            <Textheader></Textheader>
            <div className='InputSearch'>
              <div className='Seccion1'>
                <div className='FixedpositionSearch' ref={this.fixedRef}>
                  <InputSearch
                    value={this.data.searchText}
                    onResults={this._OnTextChanged}></InputSearch>
                  <div className='linkVideos'>
                    <a
                      href='https://www.youtube.com/channel/UCEFgdC9x9ljb3UjlEieqN6g'
                      target='_blank'
                      rel='noopener noreferrer'>
                      Don&apos;t miss out — subscribe to our YouTube channel
                      <YouTubeMark className="ytMark" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className='VideoList'>
              {view === 'landing' ? (
                <div className='playlistGroups'>
                  {videos === null ? (
                    <Loadergift displayVal={statusLoadingIcon} />
                  ) : videos.length === 0 ? (
                    <span className='emptyMessage'>{message}</span>
                  ) : (
                    groupKeys.map((productKey) => {
                      const meta = VideoController.groupMeta(productKey) || {
                        title: productKey,
                        subtitle: '',
                      };
                      return (
                        <PlaylistRow
                          key={productKey}
                          title={meta.title}
                          subtitle={meta.subtitle}
                          videos={groups[productKey]}
                          maxItems={4}
                          onExplore={() => this._exploreProduct(productKey)}
                          onPlay={this._openVideo}
                        />
                      );
                    })
                  )}
                </div>
              ) : (
                <>
                  <div className='expandedTitleRow'>
                    <h2 className='expandedTitle'>{activeLabel}</h2>
                    <button
                      type='button'
                      className='backToResources'
                      onClick={this._backToLanding}>
                      Back to Resources
                    </button>
                  </div>
                  <Videolist
                    videos={videos}
                    products={products}
                    activeProduct={activeProduct}
                    onSelectedFilter={this._OnFilterChanged}
                    onProductFilter={this._OnProductChange}
                    onPlayVideo={this._openVideo}
                    message={message}
                    orderByAsc={orderByAsc}>
                    <Loadergift displayVal={statusLoadingIcon} />
                  </Videolist>
                </>
              )}
            </div>
          </div>
        </div>
        {activeVideoUrl ? (
          <VideoModal url={activeVideoUrl} onClose={this._closeVideo} />
        ) : null}
      </div>
    );
  }
}
